import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_EVENTOS,
  ALL_EVENTOS,
  LOADING_ALL_EVENTOS,
} from './EventosReducer';
import {
  allEventosService,
  deleteEventosService,
  oneEventosService,
  saveEventosService,
} from './EventosService';

export const allEventosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_EVENTOS, payload: true });
    const res = await allEventosService(params);
    dispatch({ type: ALL_EVENTOS, payload: res.data });
    dispatch({ type: LOADING_ALL_EVENTOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_EVENTOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEventosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEventosService(id, data);
    notify(res.data.message);
    await allEventosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEventosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_EVENTOS, payload: data });
};

export const oneEventosAction = async (dispatch, id) => {
  try {
    const res = await oneEventosService(id);
    await setActivoEventosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEventosAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteEventosService(id);
    notify(res.data.message);
    await setActivoEventosAction(dispatch, null);
    await allEventosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
